var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_2770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 7C11.0625 8.07744 10.6345 9.11075 9.87262 9.87262C9.11075 10.6345 8.07744 11.0625 7 11.0625C5.92256 11.0625 4.88925 10.6345 4.12738 9.87262C3.36551 9.11075 2.9375 8.07744 2.9375 7C2.9375 5.92256 3.36551 4.88925 4.12738 4.12738C4.88925 3.36551 5.92256 2.9375 7 2.9375C8.07744 2.9375 9.11075 3.36551 9.87262 4.12738C10.6345 4.88925 11.0625 5.92256 11.0625 7ZM2 7C2 8.32608 2.52678 9.59785 3.46447 10.5355C4.40215 11.4732 5.67392 12 7 12C8.32608 12 9.59785 11.4732 10.5355 10.5355C11.4732 9.59785 12 8.32608 12 7C12 5.67392 11.4732 4.40215 10.5355 3.46447C9.59785 2.52678 8.32608 2 7 2C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7ZM6.53125 4.34375V7C6.53125 7.15625 6.60938 7.30273 6.74023 7.39062L8.61523 8.64062C8.83008 8.78516 9.12109 8.72656 9.26562 8.50977C9.41016 8.29297 9.35156 8.00391 9.13477 7.85938L7.46875 6.75V4.34375C7.46875 4.08398 7.25977 3.875 7 3.875C6.74023 3.875 6.53125 4.08398 6.53125 4.34375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_2770"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2H12V12H2V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockImage);
export default __webpack_public_path__ + "static/media/clock-image.32d154cbabd2f5fea661b14b0e2955ee.svg";
export { ForwardRef as ReactComponent };